import { MyLoad } from "../models/myLoad/myLoad";
import { DomainConverter, IONICWrapper, isEntitled, isMobile } from "./common";
import { MyLoadsConfigFallback, PREFERENCE_API_FALLBACK } from "./constants";
import request from "./request";
import { store } from "../store";
import { PreferenceConvertor } from "./PreferenceConvertor";
import { hideLoading } from "../actions/Login/action";
import { ToastMessage } from "./ToastMessage";
import { IDToken, User } from "../schemas/user";
import { UserDetailsNew } from "../models/userProfile/UserProfileNew.modal";
import {
  carrierTenderedData,
  inTransitData,
  loadAssignedData,
  loadCarrierData,
  loadDeliveredNeedsPPWKData,
  loadDeliveredWithPPWKData,
  storeMyLoadsFilterCount } from "../actions/carrierAssign/action";
import {
  SetShowNotification,
  fetchNewUserDetailsSuccess,
  saveUserPreferences,
  saveUserPreferencesDomain } from "../actions/App/action";

export const PREFERENCE_TAB: any = {
  home: 'home',
  search: 'search',
  myLoad: 'myLoad',
  manageMyCapacity: 'manage-capacity',
  manageUsers: 'manageUsers',
  manage: 'manage-capacity',
};

/**
 * To fetch data from the Web Service API.
 * @param {Array} role collection of role Names.
 * @returns {string} selected Role.
 */
export const getRole = (role: Array<string>) => {
  enum Role_Type {
    carrierDispatcher,
    carrierDriver,
    carrierAdmin,
  }
  let __role: string = '';
  if (role.length === 1) {
    return role[0];
  }
  for (var i = 0; i <= Object.keys(Role_Type).length; i++) {
    if (role.includes(Role_Type[i])) {
      __role = Role_Type[i];
      break;
    }
  }
  return __role;
}

export const getUserDetails = async () => {
  const userDetails = new UserDetailsNew();
  const token =
    (IONICWrapper.details.auth &&
      IONICWrapper.details.auth.tokens.access_token) ||
    '';
  const query = userDetails.getUserDetails();
  const queryPayloads = DomainConverter.domainToData<any>(query);
  const preferenceResult: any = await request([
    'FETCH_USER_DETAILS_NEW',
    'GET_USER_DETAILS_NEW',
    null,
    token,
    queryPayloads,
    "application/json"
  ]);
  const userDetailsNew =
    preferenceResult.data &&
    preferenceResult.data.getUserDetails
  if (userDetailsNew) {
    store.dispatch(fetchNewUserDetailsSuccess(userDetailsNew))
    const userRoles = userDetailsNew.memberDetailsResponse.member.userApplicationDetails[0].roles;
    const userRoleName: any = [];
    userRoles.forEach((role: any) => {
      userRoleName.push(role.roleName);
    });
    IONICWrapper.details.setAuth = { user: { ...IONICWrapper.details.auth.user, roles: userRoleName } }
  }
  if (userDetailsNew && userDetailsNew.userPreference) {
    const pref = userDetailsNew &&
      userDetailsNew.userPreference &&
      userDetailsNew.userPreference[0] &&
      userDetailsNew.userPreference[0].preferences
    const domain: string = userDetailsNew &&
      userDetailsNew.userPreference &&
      userDetailsNew.userPreference[0] &&
      userDetailsNew.userPreference[0].domain
    store.dispatch(saveUserPreferences(PreferenceConvertor(pref)));
    store.dispatch(saveUserPreferencesDomain(domain));
    store.dispatch(SetShowNotification(false));
    store.dispatch(hideLoading());
    return PreferenceConvertor(pref);
  }
  else {
    userDetailsNew && userDetailsNew.error.length > 0 && userDetailsNew.error.map((error: any) => {
      console.error("Preferences fetching error", error.message);
      (isMobile) ? ToastMessage.show(error.message) : ToastMessage.showWeb(error.message)
    }
    )
    store.dispatch(saveUserPreferences(PREFERENCE_API_FALLBACK.userPreferences));
    store.dispatch(saveUserPreferencesDomain(PREFERENCE_API_FALLBACK.userPreferencesDomain));
    store.dispatch(SetShowNotification(false));
    store.dispatch(hideLoading());
    return PREFERENCE_API_FALLBACK.userPreferences
  }
}

export const getShipmentByStateCall = async () => {
  const myLoads = new MyLoad();
  const isDriver = !isEntitled("myLoad", "carrierAssigned");
  if (isDriver) {
    myLoads.driverId = IONICWrapper?.details?.auth?.user?.upn;
  }
  myLoads.filter = {
    carrierTendered: true,
    carrierAssigned: isEntitled("myLoad", "carrierAssigned"),
    driverAssigned: true,
    inTransit: true,
    deliveredNeedsPaperWork: true,
    deliveredWithPaperWork: true
  };
  myLoads.pagination = {
    pageSize: IONICWrapper?.details?.keys?.configuration?.MyLoadsConfig.PageSize.Web || MyLoadsConfigFallback.PageSize.Web,
    pageIndex: 0,
  }
  const token =
    (IONICWrapper.details.auth &&
      IONICWrapper.details.auth.tokens.access_token) ||
    '';
  const query: any = myLoads.getMyLoadCount();
  const pageNumber = 0;
  const queryPayloads = DomainConverter.domainToData<any>(query);
  const myLoadsCount: any = await request([
    'MYLOAD',
    'CARRIER_WITH_EXPERIENCE',
    null,
    token,
    queryPayloads,
    "application/json"
  ]);
  const results =
    myLoadsCount?.data?.getShipmentsWithStopsByState;
  if (results) {
    store.dispatch(storeMyLoadsFilterCount({
      carrierTenderedFilterCount: results.carrierTenderedFilterCount,
      carrierAssignedFilterCount: results.carrierAssignedFilterCount,
      driverAssignedFilterCount: results.driverAssignedFilterCount,
      inTransitFilterCount: results.inTransitFilterCount,
      deliveredNeedsPaperWorkFilterCount: results.deliveredNeedsPaperWorkFilterCount,
      deliveredWithPaperWorkFilterCount: results.deliveredWithPaperWorkFilterCount
    }));
    store.dispatch(carrierTenderedData(results.carrierTenderedShipments || [], results.carrierTenderedCount, pageNumber));
    store.dispatch(loadCarrierData(results.carrierAssginedShipments || [], results.carrierAssignedCount, pageNumber));
    store.dispatch(loadAssignedData(results.driverAssignedShipments || [], results.driverAssignedCount, pageNumber));
    store.dispatch(inTransitData(results.inTransitShipments || [], results.inTransitCount, 0));
    store.dispatch(loadDeliveredNeedsPPWKData(results.deliveredNeedsPaperWorkShipments || [], results.deliveredNeedsPaperWorkCount, pageNumber));
    store.dispatch(loadDeliveredWithPPWKData(results.deliveredWithPaperWorkShipments || [], results.deliveredWithPaperWorkCount, pageNumber));
  }
}

export const getUserInfo = (idToken?: IDToken) => {
  if (!idToken) return;

  let email = idToken.email;
  if (idToken.emails instanceof Array) {
    email = idToken.emails[0];
  }

  return {
    id: idToken.sub,
    email: email!, // one or the other will exist
    firstName: idToken.firstName,
    lastName: idToken.lastName,
  };
}